import React from "react";
import WordGameDnD2 from "../../general/word-game-dnd-2/WordGameDnD2";

const GameQuestionDnd2 = ({
  questionId,
  score,
  question,
  imgPath,
  videoPath,
  initialWords,
  buckets,
  bucketCount,
  bucketSize,
  onScoreUpdate,
  onGameOver,
  isGameOver,
  showNextButton,
  onNext,
  showFinishButton,
  onFinish,
}) => {
  return (
    <>
      <WordGameDnD2
        key={questionId}
        onScoreUpdate={onScoreUpdate}
        prevScore={score}
        onGameOver={onGameOver}
        question={question}
        imgPath={imgPath}
        videoPath={videoPath}
        initialWords={initialWords}
        buckets={buckets}
        bucketCount={bucketCount}
        bucketSize={bucketSize}
      />

      {isGameOver && showNextButton && (
        <button className="btn nextAnswer" onClick={onNext} style={{ display: "inline-block" }}>
          Наступне завдання
        </button>
      )}

      {isGameOver && showFinishButton && (
        <button className="btn nextAnswer" onClick={onFinish} style={{ display: "inline-block" }}>
          Завершити
        </button>
      )}
    </>
  );
};

export default GameQuestionDnd2;
